/**
 * RBAC helpers for portal work item tabs (comments, field service photos) on operations teams.
 * Owner and root always pass; others follow team feature flags merged into operations feature settings.
 */

export const OPERATIONS_JOB_EDIT_WORK_ITEM_COMMENTS_KEY = 'operations_job_edit_work_item_comments';
export const OPERATIONS_JOB_EDIT_FIELD_SERVICE_PHOTOS_KEY = 'operations_job_edit_field_service_photos';

type Settings = Record<string, unknown> | null | undefined;

/** Allow creating, editing, replying to, and deleting comments on work items in the portal. */
export function isOperationsJobEditWorkItemCommentsAllowed(
  settings: Settings,
  opts: { isOwnerOrRoot: boolean; isAdmin?: boolean },
): boolean {
  if (opts.isOwnerOrRoot || opts.isAdmin) {
    return true;
  }
  return settings?.[OPERATIONS_JOB_EDIT_WORK_ITEM_COMMENTS_KEY] !== false;
}

/** Allow uploading, removing, and editing descriptions on field service photos in the portal Photos tab. */
export function isOperationsJobEditFieldServicePhotosAllowed(
  settings: Settings,
  opts: { isOwnerOrRoot: boolean; isAdmin?: boolean },
): boolean {
  if (opts.isOwnerOrRoot || opts.isAdmin) {
    return true;
  }
  return settings?.[OPERATIONS_JOB_EDIT_FIELD_SERVICE_PHOTOS_KEY] !== false;
}
